import { render, staticRenderFns } from "./editPrf.vue?vue&type=template&id=121e9526&scoped=true"
import script from "./editPrf.vue?vue&type=script&lang=js"
export * from "./editPrf.vue?vue&type=script&lang=js"
import style0 from "./editPrf.vue?vue&type=style&index=0&id=121e9526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e9526",
  null
  
)

export default component.exports